import { useEffect, useState } from 'react'

/**
 * Returns true when the viewport width is below the given breakpoint.
 */
export function useIsNarrow(breakpoint: number) {
  const [isNarrow, setIsNarrow] = useState(() => typeof window !== 'undefined' && window.innerWidth < breakpoint)

  useEffect(() => {
    const handler = () => setIsNarrow(window.innerWidth < breakpoint)
    handler()
    window.addEventListener('resize', handler, { passive: true })
    return () => window.removeEventListener('resize', handler)
  }, [breakpoint])

  return isNarrow
}
